import { Field, Form, Formik } from 'formik';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';
import Aims_img from '../../../assets/Images/aims.svg';
import { IBaseAddEditFormProps } from '../../../models/forms/IForm';
import { IOption } from '../../../models/ICommon';
import { IBaseAIMSDetails } from '../../../models/response/IAimsResponse';
import LoaderButton from '../../../shared-components/button/loader-button';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormSelect from '../../../shared-components/FormikFormHandlers/FormikFormSelect';
import Label from '../../../shared-components/label/label';
import { formatMessage } from '../../../translations/format-message';
import { AIMSPortalValidateSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import validAllowedCharacters from '../../../constants/valid-character-password';

interface IProps extends IBaseAddEditFormProps<IBaseAIMSDetails> {
  templateOptions: IOption[];
}

const AddPortalForm = (props: IProps) => {
  return (
    <>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validationSchema={AIMSPortalValidateSchema}
        validateOnBlur={false}
        onSubmit={async (values, { resetForm }) => {
          props.submitHandler(values);
          resetForm();
        }}
      >
        {({ dirty }) => {
          return (
            <Form className="user-form">
              <div className="row">
                <div className="col-7 col-xxl-6 p-5 pt-3">
                  <div className="row">
                    <div className="col-6 col-xxl-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="pattern_for_near_deadline"
                        />
                        <Field
                          name="NearDeadlineTemplateId"
                          as={FormikFormSelect}
                          options={props.templateOptions}
                          className="form-control"
                          // setDefaultValue={true}
                        />
                      </div>
                    </div>
                    <div className="col-6 col-xxl-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="pattern_for_deadline_cross"
                        />
                        <Field
                          name="DeadlineCrossTemplateId"
                          as={FormikFormSelect}
                          options={props.templateOptions}
                          className="form-control"
                          // setDefaultValue={true}
                        />
                      </div>
                    </div>
                    <div className="col-6 col-xxl-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="pattern_for_regular_mode"
                        />
                        <Field
                          name="RegularModeTemplateId"
                          as={FormikFormSelect}
                          options={props.templateOptions}
                          className="form-control"
                          // setDefaultValue={true}
                        />
                      </div>
                    </div>
                    {/* <div className="form-group formSet">
                    <Label
                      className="label-style col-form-label"
                      required={true}
                      label="pattern_for_missing_parts"
                    />
                    <Field
                      name="PatternForMissingPartTemplateId"
                      as={FormikFormSelect}
                      options={props.templateOptions}
                      setDefaultValue={true}
                    />
                  </div> */}
              <div className="col-6 col-xxl-12">
                  <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="station_code"
                        />
                        <Field
                          name="StationCode"
                          as={FormikFormInput}
                          // setDefaultValue={true}
                          className="form-control"
                          validcharacter={validAllowedCharacters}
                        />
                      </div>

                    </div>
                    <div className="col-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="url"
                        />
                        <Field
                          name="Url"
                          as={FormikFormInput}
                          // setDefaultValue={true}
                          className="form-control"
                          validcharacter={validAllowedCharacters}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          label="aims_portal_text"
                        />
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`aims_portal_text`}>
                              {formatMessage(
                                'must_be_less_than_or_equal_to_99'
                              )}
                            </Tooltip>
                          }
                        >
                          <span className="normal-info-svg">
                            <InfoCircle size={14} />
                          </span>
                        </OverlayTrigger>
                        <div className="form-group formSet">
                          <Field
                            data-testid="testProcessName"
                            className="form-control"
                            name="NearDeadLineDate"
                            type="text"
                            // defaultValue={undefined}
                            placeholder=""
                            as={FormikFormInput}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="text-end">
                        <LoaderButton
                          type="submit"
                          isLoading={props.isLoading}
                          text="button_save"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-5 col-xxl-6">
                  <div className="blog__thumb text-center">
                    <img
                      src={Aims_img}
                      alt="Aims"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AddPortalForm;
